import {
    ADD_SENSOR,
    ADD_SENSORS_FETCHED,
    REMOVE_ALL_SENSORS,
    REMOVE_SENSOR,
    UPDATE_SENSOR,
    ADD_SENSORS_FETCHED_ADMIN,
    CHANGE_CHECKEDSTATE
} from '../../actions/sensors'

const initialState = {
    list: [],
    adminSensors: [],
    count: 0
}

const sensors = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SENSORS_FETCHED_ADMIN:
            return{
                ...state,
                adminSensors : action.sensors

            }
        case ADD_SENSORS_FETCHED:
            action.sensors.forEach((x)=>{
                x.checked=false;
            })
            return {
                ...state,
                list: action.sensors,
                count: action.count
            }
        case ADD_SENSOR:
            return {
                ...state,
                adminSensors: [
                    ...state.adminSensors,
                    {
                        ...action.sensor
                    }
                ]
            }
        case CHANGE_CHECKEDSTATE:
            state.list[action.key].checked= !state.list[action.key].checked;
            return {
                ...state
            }

        case REMOVE_SENSOR:
            return {
                ...state,
                adminSensors: [
                    ...state.adminSensors.slice(0, action.index),
                    ...state.adminSensors.slice(action.index + 1)
                    ]
            }

        case UPDATE_SENSOR:
            return {
                ...state,
                adminSensors: state.adminSensors.map((sensor, index) => {
                    if (index !== action.index) return sensor

                    return action.sensor
                })
            }

        case REMOVE_ALL_SENSORS:
            return initialState
        default:
            return state
    }
}

export default sensors



// WEBPACK FOOTER //
// ./src/reducers/map/nodes.js